import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mb28h1l6umahrlb as Char__compareTo_impl_ypi4mb,
  toString22rbkbhdb5cl2 as toString,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { contains2el4s70rdq4ld as contains } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpHeadersClass;
function HttpHeaders() {
  if (HttpHeadersClass === VOID) {
    class $ {
      constructor() {
        HttpHeaders_instance = this;
        this.k4v_1 = 'Accept';
        this.l4v_1 = 'Accept-Charset';
        this.m4v_1 = 'Accept-Encoding';
        this.n4v_1 = 'Accept-Language';
        this.o4v_1 = 'Accept-Ranges';
        this.p4v_1 = 'Age';
        this.q4v_1 = 'Allow';
        this.r4v_1 = 'ALPN';
        this.s4v_1 = 'Authentication-Info';
        this.t4v_1 = 'Authorization';
        this.u4v_1 = 'Cache-Control';
        this.v4v_1 = 'Connection';
        this.w4v_1 = 'Content-Disposition';
        this.x4v_1 = 'Content-Encoding';
        this.y4v_1 = 'Content-Language';
        this.z4v_1 = 'Content-Length';
        this.a4w_1 = 'Content-Location';
        this.b4w_1 = 'Content-Range';
        this.c4w_1 = 'Content-Type';
        this.d4w_1 = 'Cookie';
        this.e4w_1 = 'DASL';
        this.f4w_1 = 'Date';
        this.g4w_1 = 'DAV';
        this.h4w_1 = 'Depth';
        this.i4w_1 = 'Destination';
        this.j4w_1 = 'ETag';
        this.k4w_1 = 'Expect';
        this.l4w_1 = 'Expires';
        this.m4w_1 = 'From';
        this.n4w_1 = 'Forwarded';
        this.o4w_1 = 'Host';
        this.p4w_1 = 'HTTP2-Settings';
        this.q4w_1 = 'If';
        this.r4w_1 = 'If-Match';
        this.s4w_1 = 'If-Modified-Since';
        this.t4w_1 = 'If-None-Match';
        this.u4w_1 = 'If-Range';
        this.v4w_1 = 'If-Schedule-Tag-Match';
        this.w4w_1 = 'If-Unmodified-Since';
        this.x4w_1 = 'Last-Modified';
        this.y4w_1 = 'Location';
        this.z4w_1 = 'Lock-Token';
        this.a4x_1 = 'Link';
        this.b4x_1 = 'Max-Forwards';
        this.c4x_1 = 'MIME-Version';
        this.d4x_1 = 'Ordering-Type';
        this.e4x_1 = 'Origin';
        this.f4x_1 = 'Overwrite';
        this.g4x_1 = 'Position';
        this.h4x_1 = 'Pragma';
        this.i4x_1 = 'Prefer';
        this.j4x_1 = 'Preference-Applied';
        this.k4x_1 = 'Proxy-Authenticate';
        this.l4x_1 = 'Proxy-Authentication-Info';
        this.m4x_1 = 'Proxy-Authorization';
        this.n4x_1 = 'Public-Key-Pins';
        this.o4x_1 = 'Public-Key-Pins-Report-Only';
        this.p4x_1 = 'Range';
        this.q4x_1 = 'Referer';
        this.r4x_1 = 'Retry-After';
        this.s4x_1 = 'Schedule-Reply';
        this.t4x_1 = 'Schedule-Tag';
        this.u4x_1 = 'Sec-WebSocket-Accept';
        this.v4x_1 = 'Sec-WebSocket-Extensions';
        this.w4x_1 = 'Sec-WebSocket-Key';
        this.x4x_1 = 'Sec-WebSocket-Protocol';
        this.y4x_1 = 'Sec-WebSocket-Version';
        this.z4x_1 = 'Server';
        this.a4y_1 = 'Set-Cookie';
        this.b4y_1 = 'SLUG';
        this.c4y_1 = 'Strict-Transport-Security';
        this.d4y_1 = 'TE';
        this.e4y_1 = 'Timeout';
        this.f4y_1 = 'Trailer';
        this.g4y_1 = 'Transfer-Encoding';
        this.h4y_1 = 'Upgrade';
        this.i4y_1 = 'User-Agent';
        this.j4y_1 = 'Vary';
        this.k4y_1 = 'Via';
        this.l4y_1 = 'Warning';
        this.m4y_1 = 'WWW-Authenticate';
        this.n4y_1 = 'Access-Control-Allow-Origin';
        this.o4y_1 = 'Access-Control-Allow-Methods';
        this.p4y_1 = 'Access-Control-Allow-Credentials';
        this.q4y_1 = 'Access-Control-Allow-Headers';
        this.r4y_1 = 'Access-Control-Request-Method';
        this.s4y_1 = 'Access-Control-Request-Headers';
        this.t4y_1 = 'Access-Control-Expose-Headers';
        this.u4y_1 = 'Access-Control-Max-Age';
        this.v4y_1 = 'X-Http-Method-Override';
        this.w4y_1 = 'X-Forwarded-Host';
        this.x4y_1 = 'X-Forwarded-Server';
        this.y4y_1 = 'X-Forwarded-Proto';
        this.z4y_1 = 'X-Forwarded-For';
        this.a4z_1 = 'X-Forwarded-Port';
        this.b4z_1 = 'X-Request-ID';
        this.c4z_1 = 'X-Correlation-ID';
        this.d4z_1 = 'X-Total-Count';
        this.e4z_1 = 'Last-Event-ID';
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.f4z_1 = ['Transfer-Encoding', 'Upgrade'];
        this.g4z_1 = asList(this.f4z_1);
      }
      h4z(name) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(name)) {
          var item = charSequenceGet(name, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) <= 0 || isDelimiter(item)) {
            throw IllegalHeaderNameException().s4z(name, _unary__edvuaz);
          }
        }
      }
      i4z(value) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(value)) {
          var item = charSequenceGet(value, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) < 0 && !(item === _Char___init__impl__6a9atx(9))) {
            throw IllegalHeaderValueException().z4z(value, _unary__edvuaz);
          }
        }
      }
    }
    initMetadataForObject($, 'HttpHeaders');
    HttpHeadersClass = $;
  }
  return HttpHeadersClass;
}
var HttpHeaders_instance;
function HttpHeaders_getInstance() {
  if (HttpHeaders_instance === VOID)
    new (HttpHeaders())();
  return HttpHeaders_instance;
}
var UnsafeHeaderExceptionClass;
function UnsafeHeaderException() {
  if (UnsafeHeaderExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static e50(header) {
        var $this = this.n2('Header(s) ' + header + ' are controlled by the engine and ' + 'cannot be set explicitly');
        captureStack($this, $this.d50_1);
        return $this;
      }
    }
    initMetadataForClass($, 'UnsafeHeaderException');
    UnsafeHeaderExceptionClass = $;
  }
  return UnsafeHeaderExceptionClass;
}
function isDelimiter(ch) {
  return contains('"(),/:;<=>?@[\\]{}', ch);
}
var IllegalHeaderNameExceptionClass;
function IllegalHeaderNameException() {
  if (IllegalHeaderNameExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static s4z(headerName, position) {
        var tmp = "Header name '" + headerName + "' contains illegal character '" + toString(charCodeAt(headerName, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerName, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.n2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.r4z_1);
        $this.p4z_1 = headerName;
        $this.q4z_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderNameException');
    IllegalHeaderNameExceptionClass = $;
  }
  return IllegalHeaderNameExceptionClass;
}
var IllegalHeaderValueExceptionClass;
function IllegalHeaderValueException() {
  if (IllegalHeaderValueExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static z4z(headerValue, position) {
        var tmp = "Header value '" + headerValue + "' contains illegal character '" + toString(charCodeAt(headerValue, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerValue, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.n2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.y4z_1);
        $this.w4z_1 = headerValue;
        $this.x4z_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderValueException');
    IllegalHeaderValueExceptionClass = $;
  }
  return IllegalHeaderValueExceptionClass;
}
//region block: exports
export {
  HttpHeaders_getInstance as HttpHeaders_getInstance2ik2fiom4sc0n,
  UnsafeHeaderException as UnsafeHeaderException3ncvrrp48xjzq,
};
//endregion

//# sourceMappingURL=HttpHeaders.mjs.map
